import { gate } from 'hub-http/gates';
import { useGetIsUngated } from './useGetIsUngated';
export const useGetIsUngatedForConditionalAssociations = ({
  enableDependentAssociations
}) => {
  const getIsUngated = useGetIsUngated();
  const isUngated = getIsUngated(gate('CRM:ConditionalLogic:ConditionalAssociations'));
  return isUngated && enableDependentAssociations;
};